export const importProductsXlsx = {
	header: {
		title: "Importar produtos",
	},
	layout: {
		importProductsTable: "Importe sua tabela de produtos",
		tutorial: "Adicione 1 ou mais produtos de uma vez importando uma planilha.",
	},
	form: {
		totalProducts: "Total de produtos",
		successfullyImported: "Produtos importados",
		productsWithErrors: "Produtos com erro",
		alert: {
			title: "Produtos com erro",
			message:
				"Identificamos alguns produtos com informações incorretas. Baixe a planilha com os erros, corrija os dados e, em seguida, realize a importação novamente.",
		},
		tooltip: {
			totalProducts: "Sua tabela possuia {{totalProducts}} produtos",
			successfullyImported: "{{totalProducts}} produtos já foram cadastrados com sucesso",
			productsWithErrors: "Baixe a tabela com erros e faça o upload novamente",
		},
		warning: {
			title: "Atenção",
			description:
				"O valor dos produtos é informado em centavos, ex: 123 equivale a R$1,23",
		},
		importProductsActiveByDefault: "Importar produtos com o status ativo",
	},
	sheet: {
		columns: {
			name: "Nome",
			kind: "Tipo de produto",
			category: "Categoria",
			menuCategory: "Categoria do menu",
			description: "Descrição",
			image: "Imagem (ID)",
			imagePreview: "Imagem (visualização)",
			imageIndex: "Imagem (índice)",
			existingImage: "Imagem original",
			basicStorageUnit: "Unidade de medida",
			price: "Preço",
			priceInCents: "Preço em centavos",
			bars: "Bares (separados por ponto e vírgula)",
			hasAlcohol: "Contém álcool?",
			isHiddenFromApp: "Não exibir produto no aplicativo ZigApp",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
			fiscalCest: "Fiscal - CEST",
			fiscalProductGroup: "Fiscal - Grupo fiscal",
			fiscalProfile: "Fiscal - Perfil fiscal",
			isStockable: "Estocável",
			beerBrand: "Marca da cerveja",
			beerStyle: "Estilo da cerveja",
			beerAbv: "ABV - Teor alcoólico",
		},
		sampleFileName: "exemplo_importacao_produtos",
		errorFileName: "importacao_produtos_com_erros",
		auxiliarSheets: {
			bars: "Bares",
			images: {
				ptBr: "PT-BR",
				esMx: "ES-MX",
				id: "ID",
				url: "URL",
				name: "Imagens",
			},
		},
	},
};

export type ImportProductsXlsxTranslation = typeof importProductsXlsx;
